// Timer on the board: the round button next to the weather, the sheet and the alarm.
export const kioskTimerEn = {
    open: 'Timer',
    openRunning: 'Timer: {time} left',
    title: 'Timer',
    minutes: '{n} min',
    custom: 'Choose yourself',
    less: 'One minute less',
    more: 'One minute more',
    minutesUnit: 'minutes',
    forWhat: 'What for?',
    labels: {
        teeth: 'Brushing teeth',
        homework: 'Homework',
        screen: 'Screen time',
        cooking: 'Cooking',
    },
    start: 'Start',
    left: '{time} left',
    paused: 'Paused',
    pause: 'Pause',
    resume: 'Resume',
    plusOne: '+1 min',
    stop: 'Stop',
    done: "Time's up!",
    /** Rustig, buiten het thema Kinderen. */
    doneCalm: 'Time is up',
};
//# sourceMappingURL=kioskTimer.en.js.map